var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18687",
    "data-name": "Group 18687",
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.123,
    height: 123.613,
    viewBox: "0 0 101.123 123.613",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7492",
    "data-name": "Path 7492",
    d: "M101.042,6.9H9.277A4.706,4.706,0,0,0,4.6,11.577h0v114.26a4.706,4.706,0,0,0,4.677,4.677h91.764a4.706,4.706,0,0,0,4.677-4.677h0V11.689A4.594,4.594,0,0,0,101.042,6.9Zm-1.67,117.378H10.948V13.359H99.371Z",
    transform: "translate(-4.6 -6.9)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7493",
    "data-name": "Path 7493",
    d: "M24.73,37.159H81.748a3.23,3.23,0,0,0,0-6.459H24.73a3.23,3.23,0,0,0,0,6.459Z",
    transform: "translate(-2.68 -4.19)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7494",
    "data-name": "Path 7494",
    d: "M24.73,55.959H81.748a3.23,3.23,0,1,0,0-6.459H24.73a3.23,3.23,0,1,0,0,6.459Z",
    transform: "translate(-2.68 -2.059)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7495",
    "data-name": "Path 7495",
    d: "M24.73,74.659H81.748a3.23,3.23,0,1,0,0-6.459H24.73a3.232,3.232,0,0,0-3.23,3.23A3.163,3.163,0,0,0,24.73,74.659Z",
    transform: "translate(-2.68 0.07)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7496",
    "data-name": "Path 7496",
    d: "M24.73,94.859H81.748a3.23,3.23,0,1,0,0-6.459H24.73a3.23,3.23,0,1,0,0,6.459Z",
    transform: "translate(-2.68 2.379)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotation);
export default __webpack_public_path__ + "static/media/Icon_Quotation.bf4068053f82f92306d919a8ce581d1c.svg";
export { ForwardRef as ReactComponent };